export default "__VITE_ASSET__BLfQbERt__"